export function normalizeEscapedText(value: string): string {
  return value
    .split('\\\\r\\\\n').join('\n')
    .split('\\r\\n').join('\n')
    .split('\\\\n').join('\n')
    .split('\\n').join('\n')
    .split('\\\\r').join('\n')
    .split('\\r').join('\n')
    .split('\\\\t').join(' ')
    .split('\\t').join(' ')
    .replace(/\r\n?/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

export function splitNarrativeParagraphs(value: string): string[] {
  const normalized = normalizeEscapedText(value)
  if (!normalized) return []
  const explicit = normalized.split(/\n\s*\n/).map((part) => part.trim()).filter(Boolean)
  if (explicit.length > 1) return explicit
  const sentences = normalized.split(/(?<=[.!?…])\s+/).map((part) => part.trim()).filter(Boolean)
  if (sentences.length < 4) return [normalized]
  const groups: string[][] = Array.from({ length: Math.min(3, sentences.length) }, () => [])
  sentences.forEach((sentence, index) => groups[Math.min(groups.length - 1, Math.floor(index * groups.length / sentences.length))].push(sentence))
  return groups.filter((group) => group.length > 0).map((group) => group.join(' '))
}
